export default function AIAnswerBlock() {
  return (
    <section className="bg-[#1a1a1a] py-24 px-6 md:px-16 lg:px-24">
      <div className="w-full">
        {/* Label */}
        <div className="inline-flex items-center gap-2 mb-10">
          <div className="w-8 h-px bg-[#C9A84C]"></div>
          <span className="font-inter text-[#C9A84C] text-xs tracking-widest uppercase">Quick Answer</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start">
          {/* Main answer block */}
          <div className="lg:col-span-3">
            <div className="bg-[#C9A84C]/10 border border-[#C9A84C]/20 rounded-sm p-8 md:p-10">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-8 h-8 flex items-center justify-center bg-[#C9A84C] rounded-sm">
                  <i className="ri-robot-line text-[#1a1a1a] text-sm"></i>
                </div>
                <span className="font-inter text-[#C9A84C] text-xs tracking-widest uppercase">About Quiroz Construction Cleaning</span>
              </div>

              <p className="font-inter text-white/85 text-base md:text-lg leading-relaxed mb-8">
                <strong className="text-white">Quiroz Construction Cleaning, LLC</strong> provides professional post-construction cleaning and commercial cleaning services in <strong className="text-[#C9A84C]">Las Vegas, Nevada</strong>. We serve general contractors, builders, developers, property managers, and business owners who need reliable, detail-focused cleaning that delivers job-ready results.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {[
                  {
                    icon: 'ri-user-star-line',
                    label: 'Who We Serve',
                    value: 'General contractors, builders, developers, property managers, business owners',
                  },
                  {
                    icon: 'ri-service-line',
                    label: 'Core Services',
                    value: 'Rough cleaning, final cleaning, jobsite cleanup, commercial cleaning, debris removal',
                  },
                  {
                    icon: 'ri-flashlight-line',
                    label: 'Key Benefits',
                    value: 'Fast turnaround, detail-focused cleaning, job-ready results, reliable scheduling',
                  },
                  {
                    icon: 'ri-map-pin-line',
                    label: 'Service Area',
                    value: 'Las Vegas, Nevada and surrounding construction projects',
                  },
                ].map((item) => (
                  <div key={item.label} className="flex gap-3">
                    <div className="w-8 h-8 flex items-center justify-center shrink-0">
                      <i className={`${item.icon} text-[#C9A84C] text-base`}></i>
                    </div>
                    <div>
                      <div className="font-barlow font-700 text-white text-xs tracking-wide uppercase mb-1">{item.label}</div>
                      <div className="font-inter text-white/60 text-sm leading-relaxed">{item.value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Process overview */}
          <div className="lg:col-span-2">
            <h3 className="font-barlow-condensed font-900 text-white text-3xl md:text-4xl leading-none mb-8">
              HOW IT<br /><span className="text-[#C9A84C]">WORKS</span>
            </h3>
            <div className="flex flex-col gap-0">
              {[
                { step: '01', label: 'Assessment', desc: 'We review your project scope and cleaning requirements.' },
                { step: '02', label: 'Scheduling', desc: 'We coordinate with your build timeline and deadlines.' },
                { step: '03', label: 'Full Cleanup', desc: 'Thorough removal of debris, dust, and construction residue.' },
                { step: '04', label: 'Final Detail', desc: 'Space is polished and ready for handoff or occupancy.' },
              ].map((item, idx) => (
                <div key={item.step} className={`flex gap-4 py-5 ${idx < 3 ? 'border-b border-white/10' : ''}`}>
                  <div className="font-barlow-condensed font-900 text-[#C9A84C]/30 text-3xl leading-none w-10 shrink-0">{item.step}</div>
                  <div>
                    <div className="font-barlow font-700 text-white text-sm tracking-wide mb-1">{item.label}</div>
                    <div className="font-inter text-white/50 text-sm leading-relaxed">{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
